module.exports = __webpack_public_path__ + "static/media/mobile_graphic4.3595f086.png";